import { render } from "./selection_box.vue?vue&type=template&id=56411722"
import script from "./selection_box.vue?vue&type=script&lang=js"
export * from "./selection_box.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/docuseal-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__